import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const admin = axios.create({
  baseURL: API,
  withCredentials: true,
});

admin.interceptors.request.use((config) => {
  const t = localStorage.getItem("fl_admin_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function saveToken(t) {
  localStorage.setItem("fl_admin_token", t);
}

export function clearToken() {
  localStorage.removeItem("fl_admin_token");
}

export function getToken() {
  return localStorage.getItem("fl_admin_token");
}
